import { component } from 'picoapp'
import $ from 'quantdom'

export default component((node) => {
  const atcElement = $('add-button.js-main-atc').el()
  const atcPosition = atcElement.offsetTop
  const headerHeight = $('#SiteHeader').el().offsetHeight
  const observer = new IntersectionObserver(
    ([entry]) => {
      const exitThreshold = window.scrollY + headerHeight
      if (entry.isIntersecting) {
        const chatIcon = $('#kustomer-ui-sdk-iframe').el()
        $(node).attr('aria-expanded', false)
        if (chatIcon && window.innerWidth < 800) {
          chatIcon.style.transform = 'translateY(0px)'
        }
      } else if (exitThreshold > atcPosition && !entry.isIntersecting) {
        $(node).attr('aria-expanded', true)
        const chatIcon = $('#kustomer-ui-sdk-iframe').el()
        if (chatIcon && window.innerWidth < 800) {
          const stickyAtcHeight = $(node).el().offsetHeight
          chatIcon.style.transform = `translateY(-${stickyAtcHeight}px)`
        }
      } else {
        $(node).attr('aria-expanded', false)
        const chatIcon = $('#kustomer-ui-sdk-iframe').el()
        if (chatIcon && window.innerWidth < 800) {
          chatIcon.style.transform = 'translateY(0px)'
        }
      }
    },
    { root: null, rootMargin: `-${headerHeight}px 0px 0px 0px`, threshold: 0.1 }
  )

  observer.observe(atcElement)
})
